

















































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {ResponsavelConfigSms} from '@/model/resource/ResponsavelConfigSms'
import {ResponsavelConfigSmsCollection} from '@/model/collection/ResponsavelConfigSmsCollection'
import {ListResponsavelConfigSmsSchema} from '@/schema/resource/ResponsavelConfigSms/ListResponsavelConfigSmsSchema'
import {CsvResponsavelConfigSmsSchema} from '@/schema/resource/ResponsavelConfigSms/CsvResponsavelConfigSmsSchema'

@Component
export default class ListResponsavelConfigSmsView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListResponsavelConfigSmsSchema()
  collection = new ResponsavelConfigSmsCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: ResponsavelConfigSms) {
    Helper.pushByName('editResponsavelConfigSms', item.$id)
  }

  async removeItem(item: ResponsavelConfigSms) {
    await new DialogRemove(item).confirm(() =>
      item.removeResponsavelConfigSms()
    )
    await this.collection.listResponsavelConfigSms()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new ResponsavelConfigSmsCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvResponsavelConfigSms()
    new CsvResponsavelConfigSmsSchema().downloadCsv(csv.all())
  }
}
